import LogoMark from "./LogoMark";

export default function LogoWordmark({ className = "", dark = false }) {
  const textColor = dark ? "text-charcoal" : "text-offwhite";
  const subColor = dark ? "text-steel" : "text-offwhite/70";

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <LogoMark className={`h-9 w-9 ${dark ? "text-brick" : "text-brick-light"}`} />
      <div className="leading-none">
        <div className={`font-display text-2xl font-semibold tracking-wide ${textColor}`}>
          VCO
        </div>
        <div className={`font-display text-[0.6rem] font-medium tracking-[0.3em] ${subColor}`}>
          GROUP
        </div>
      </div>
    </div>
  );
}
